import { useState } from "react";
import { HelpCircle } from "lucide-react";
import { usePageContext } from "vike-react/usePageContext";
import styles from "./HelpIcon.module.css";

const HELP_CONTENT: Record<string, { title: string; text: string }> = {
  "/": {
    title: "Welcome to OddStack",
    text: "Navigate using the menu above to explore our work, learn about the team, see our impact, or get in touch.",
  },
  "/work": {
    title: "Our Projects",
    text: "Browse our selected projects. Click any card to dive into the full case study with details on our process and results.",
  },
  "/apps": {
    title: "Our Apps",
    text: "Mobile apps we've built from real-life problems — Invisible Touch, PostPilot, and Proof.",
  },
  "/proof": {
    title: "Proof",
    text: "Photo delivery for photographers: deliver every shoot from your own Dropbox or Google Drive, in galleries that never expire. For help, visit proofdelivery.app/support.",
  },
  // /bpapp/privacy and /bpapp/terms are Proof's policies (the app was BPapp).
  "/bpapp": {
    title: "Proof",
    text: "Proof's policies. Proof is photo delivery for photographers. For help, visit proofdelivery.app/support.",
  },
  "/invisible-touch": {
    title: "Invisible Touch",
    text: "A quiet way to let your people know you're okay — without explaining yourself. Tap a color, your circle gets the message you wrote at baseline.",
  },
  "/about": {
    title: "About Us",
    text: "Learn about our story, meet the team, and discover what makes OddStack different.",
  },
  "/impact": {
    title: "Our Impact",
    text: "The numbers behind our work — projects shipped, partners, awards, and global reach.",
  },
  "/contact": {
    title: "Get In Touch",
    text: "Fill out the form to start a conversation. We typically respond within 24 hours.",
  },
  "/journal": {
    title: "Journal",
    text: "Our thoughts on design, engineering, and the creative process.",
  },
  "/shop": {
    title: "OddStack Shop",
    text: "Browse our print-on-demand apparel. Open a product to pick your size and color, add it to your cart, and check out — items are printed on demand and shipped to you.",
  },
  "/redeem": {
    title: "Redeem Your Code",
    text: "Enter the project code we sent you to view your website build quote and securely purchase via Stripe.",
  },
  "/admin": {
    title: "Demo Manager",
    text: "Upload and deploy client demo sites. Enter your admin password, then upload a .zip of your HTML site to deploy it live.",
  },
};

export default function HelpIcon() {
  const [open, setOpen] = useState(false);
  const { urlPathname: pathname } = usePageContext();

  const baseRoute = "/" + (pathname.split("/")[1] ?? "");
  const content = HELP_CONTENT[baseRoute] ?? HELP_CONTENT["/"];

  return (
    <div className={styles.wrapper}>
      {open && (
        <div className={styles.panel}>
          <div className={styles.panelTitle}>{content.title}</div>
          <p className={styles.panelText}>{content.text}</p>
          <a href="/contact" className={styles.panelLink}>
            Need help? Contact us →
          </a>
        </div>
      )}
      <button
        className={styles.button}
        onClick={() => setOpen(!open)}
        aria-label="Help"
      >
        <HelpCircle size={22} strokeWidth={1.5} />
      </button>
    </div>
  );
}
